import { useContext, ref, readonly } from "@nuxtjs/composition-api";
import { Logger } from "@wemade-vsf/core";
function useBlog() {
  const loading = ref(false);
  const error = ref({
    getPostDetails: null,
    getPostList: null,
    getMeta: null
  });
  const { app } = useContext();
  const getPostDetails = async (urlKey) => {
    var _a, _b, _c;
    Logger.debug(`useBlog/${urlKey}/getBlogPostDetails`);
    let post = null;
    try {
      loading.value = true;
      const { data } = await app.$vsf.$magento.api.blogPost(urlKey);
      post = (_c = (_b = (_a = data.mpBlogPosts) == null ? void 0 : _a.items) == null ? void 0 : _b[0]) != null ? _c : null;
      error.value.getPostDetails = null;
    } catch (err) {
      error.value.getPostDetails = err;
      Logger.error(`useBlog/${urlKey}/getBlogPostDetails`, err);
    } finally {
      loading.value = false;
    }
    return post;
  };
  const getPostList = async (params) => {
    var _a;
    params = {
      filter: { enabled: { eq: "1" } },
      action: "get_post_list",
      sortBy: "Latest",
      ...params
    };
    let result = null;
    try {
      loading.value = true;
      const { data } = await app.$vsf.$magento.api.blogPostList(params);
      result = (_a = data == null ? void 0 : data.mpBlogPosts) != null ? _a : null;
      error.value.getPostList = null;
    } catch (err) {
      error.value.getPostList = err;
    } finally {
      loading.value = false;
    }
    return result;
  };
  const getMetaData = async () => {
    var _a, _b, _c, _d, _e, _f;
    let result = null;
    try {
      loading.value = true;
      const { data } = await app.$vsf.$magento.api.blogConfig();
      result = {
        name: ((_b = (_a = data == null ? void 0 : data.mpBlogConfigs) == null ? void 0 : _a.general) == null ? void 0 : _b.name) || null,
        meta_title: ((_d = (_c = data == null ? void 0 : data.mpBlogConfigs) == null ? void 0 : _c.seo) == null ? void 0 : _d.meta_title) || null,
        meta_description: ((_f = (_e = data == null ? void 0 : data.mpBlogConfigs) == null ? void 0 : _e.seo) == null ? void 0 : _f.meta_description) || null
      };
    } catch (err) {
      error.value.getMeta = err;
      Logger.error(`useBlog/getMetaData`, err);
    } finally {
      loading.value = false;
    }
    return result;
  };
  return {
    loading: readonly(loading),
    error: readonly(error),
    getPostDetails,
    getPostList,
    getMetaData
  };
}
import { BlogPost } from "./useBlog";
export {
  BlogPost,
  useBlog
};
